import { render } from "./AcceptConsent.vue?vue&type=template&id=558f2db0&scoped=true"
import script from "./AcceptConsent.vue?vue&type=script&lang=js"
export * from "./AcceptConsent.vue?vue&type=script&lang=js"

import "./AcceptConsent.vue?vue&type=style&index=0&id=558f2db0&lang=scss&child-component=Captcha"
import "./AcceptConsent.vue?vue&type=style&index=1&id=558f2db0&lang=scss&scoped=true"

import exportComponent from "/data/tfs-agent-build/agent/_work/7/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558f2db0"],['__file',"src/views/AcceptConsent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "558f2db0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('558f2db0', __exports__)) {
    api.reload('558f2db0', __exports__)
  }
  
  module.hot.accept("./AcceptConsent.vue?vue&type=template&id=558f2db0&scoped=true", () => {
    api.rerender('558f2db0', render)
  })

}


export default __exports__